export interface IParameterOption {
  key: string;
  label: string;
  isCategory?: boolean;
  category: string;
}

export interface IParameterInfo {
  key: string;
  label: string; // displayed title
  reactKey?: number; // DO NOT POPULATE. this is automated // number that will be converted to string to be used as a unique key
  Component?: (props: any) => JSX.Element;
  props?: Record<string, any>;
  apiKeys: string[];
}

const DEFAULT_STRING = 'Default';

export const emptyParameterInfo: IParameterInfo = {
  key: DEFAULT_STRING,
  label: '',
  apiKeys: [],
};

export const extractActiveParamKeys = (parameters: IParameterInfo[]) => {
  const keys: string[] = [];
  parameters.forEach((param) => {
    if (param.key && param.key !== DEFAULT_STRING) {
      keys.push(param.key);
    }
  });
  return new Set(keys);
};
